<template>
  <v-dialog
    v-model="show"
    :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'"
  >
    <v-card class="rounded-xl" color="#ffffffD9">
      <v-card-title class="">
        <span
          class="
            primary--text
            text-subtitle-2
            text-sm-subtitle-1
            text-md-subtitle-1
            text-lg-subtitle-1
            text-xl-subtitle-1
            font-weight-bold
          "
          >Hacer cliente</span
        >
      </v-card-title>
      <v-card-text class="my-0 py-0">
        <span> ¿Seguro que quieres crear un cliente? </span>
      </v-card-text>
      <v-card-actions>
        <v-container fluid>
          <v-row justify="end" align="end">
            <v-btn
              color="primary"
              @click="show = false"
              text
              class="
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
            >
              CANCELAR
            </v-btn>
            <v-btn
              color="primary"
              @click="makeClient"
              text
              class="
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
            >
              ACEPTAR
            </v-btn>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  data: () => ({
    data: { error: false, message: "", name: "" },
  }),
  created() {
    this.data.name = this.name;
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    makeClient() {
      this.show = false;
      this.$emit("makeClient");
    },
  },
};
</script>

<style scoped>
</style>
